import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { resolutions, Routes } from '../../utils/constants'
import './index.sass'

class ServicesCard extends Component {
  state = {
    width: window.innerWidth,
  }
  updateDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  render = () => {
    const { width } = this.state
    const { label, value, t, lng, serviceTab, type = 'service' } = this.props
    const className = value.split(' ').join('-')
    const servicePath =
      lng === 'en'
        ? `${Routes.SERVICES}/${serviceTab}/${value}`
        : `/${lng}${Routes.SERVICES}/${serviceTab}/${value}`
    const blogPath =
        lng === 'en'
          ? `${Routes.BLOG}/${value}`
          : `/${lng}${Routes.BLOG}/${value}`
    return (
      <Link className="card-wrapper" to={type === 'service'? servicePath : blogPath}>
        <div className={`card-image card-image-${className}`}>
          {width > resolutions.tablet && (
            <>
              <div className="card-image-mask">
                <span className="nav-arrow"></span>
              </div>
              <p className="subtitle-2">{type === 'service'? t(`services.${label}`) : t(`${label}`)}</p>
            </>
          )}
        </div>
        {width < resolutions.tablet && (
          <div className="card-descr">
            <p className="subtitle-2">{type === 'service' ? t(`services.${label}`) : t(`${label}`)}</p>
            <span className="nav-arrow"></span>
          </div>
        )}
      </Link>
    )
  }
}

export default withRouter(translate('translations')(ServicesCard))
